import GroupHeader from './GroupHeader';

export default GroupHeader;
